import React from 'react';
import {inject, observer} from 'mobx-react';
import {toJS} from 'mobx';
import {Popover} from 'antd';
import {WeaLocaleProvider, WeaTools, WeaHelpfulTip, WeaBrowser, WeaAvatar} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;

import E8LeftMenuTop4Email from './E8LeftMenuTop4Email';

@inject('portalThemeStore')
@observer
class E8LeftMenuTop extends React.Component {
    constructor(props) {
        super(props);
        this.onVisibleChange = this.onVisibleChange.bind(this);
        this.onOpenCard = this.onOpenCard.bind(this);
        this.onChangeAccount = this.onChangeAccount.bind(this);
        this.onFontSizeChange = this.onFontSizeChange.bind(this);
        this.onLangChange = this.onLangChange.bind(this);
    }

    componentWillMount() {
        const {portalThemeStore} = this.props;
        portalThemeStore.getAccount();
        portalThemeStore.getAccountMoreMenu();
    }

    render() {
        const {portalThemeStore} = this.props;
        const {multiLangs, langId, themeInfo, fontSettingVisible, langSettingVisible, account, accountSize, accountList, accountListVisible, topMenuObj , accountMoreMenu} = portalThemeStore;
        const _account = toJS(account);
        const _accountList = toJS(accountList);

        const {themeData = {},themeFontSize = '12'} = themeInfo;
        const {hrmcolor} = themeData;

        const {username = '', deptname = ''} = _account;

        const {topMenuSelected = {}} = topMenuObj;
        const _topMenuSelected = toJS(topMenuSelected);
        const {id:topMenuId, sname:topMenuName} = _topMenuSelected;

        const {userid:curuserid, showSearch,fontSetting} = _account;
        let langText = '';
        multiLangs.forEach((item) => {
            if (item.id == langId) {
                langText = item.language;
            }
        });
     
        if(fontSettingVisible){
            $('.e8left-e9header-font-setting-overlay').css('display','block')
        }else{
            $('.e8left-e9header-font-setting-overlay').css('display','none')
        }
       
        if(langSettingVisible){
            $('.e8left-e9header-lang-setting-overlay').css('display','block')
        }else{
            $('.e8left-e9header-lang-setting-overlay').css('display','none')
        }

        const aclistComp = (
            <div id="e9header-account-content" className="e9header-account-content">
            {
                accountSize > 1 ? (
                <div>
                    <div className="e9header-account-title">
                        <span>{getLabel(131608, '主次账号切换')}</span>
                    </div>
                    {
                        showSearch ? (
                            <div className="e9header-account-search">
                                <div className="e9header-account-search-title">
                                    <span>{getLabel(507638, '分部')}</span>
                                </div>
                                <div className="e9header-account-search-browser">
                                    <WeaBrowser
                                        title={getLabel(507638, '分部')}
                                        type={164}
                                        isSingle={true}
                                        tabs={[
                                            {key: '1', name: getLabel(384541, '按组织架构'), selected: false},
                                            {key: '2', name: getLabel(130619, '按列表'), selected: false, dataParams: {list: 1}}
                                        ]}
                                        hasAdvanceSerach={true}
                                        getPopupContainer={() => document.getElementById('e9header-account-content')}
                                        onOpen={() => window.accountListVisible = true}
                                        onClose={() => window.accountListVisible = false}
                                        onChange={id => portalThemeStore.getAccountList(id)}
                                    />
                                </div>
                                <div style={{clear: 'both'}} />
                            </div>
                        ) : ''
                    }
                    <div className="e9header-account-splitter"></div>
                </div>
                ): ''
            }
                <div className="e9header-account-list">
                    {
                        _accountList.map((item, index) => {
                            let {userid, usertype, username, jobs, subcompanyname, deptname} = item;
                            deptname = `${subcompanyname}/${deptname}`;
                            deptname = deptname == '/' ? '' : deptname;

                            return (
                                <div key={index}>
                                    <div className="e9header-account-item">
                                        <div className="e9header-account-item-img" onClick={e => this.onOpenCard(e, userid)}>
                                            <WeaAvatar userId={userid}/>
                                        </div>
                                        <div className="e9header-account-item-info"
                                            onClick={e => {
                                                if (userid != curuserid) {
                                                  this.onChangeAccount(userid);
                                                } else {
                                                  this.onOpenCard(e, userid);
                                                }
                                            }}
                                        >
                                            {usertype == '0' && <span className="e9header-account-item-usertype"><i className="icon-coms02-Main-account-number"/></span>}
                                            <span title={username} className="e9header-account-item-username" onClick={e => this.onOpenCard(e, userid)}>{username}</span>
                                            <span title={jobs} className="e9header-account-item-jobs">{jobs}</span>
                                            <br />
                                            <span title={deptname} className="e9header-account-item-deptname">{deptname}</span>
                                        </div>
                                        {userid == curuserid ? <i className="icon-coms02-icon-Completion e9header-account-checked" /> : ''}
                                    </div>
                                    <div className="e9header-account-splitter"></div>
                                </div>
                            );
                        })
                    }
                </div>
                <div className="e9header-account-setting">
                    {
                        accountMoreMenu.map((item, index) => {
                            if (item.sType == 'font') {
                                return (
                                    <Popover
                                        key={index}
                                        trigger="click"
                                        placement="leftTop"
                                        content={<FontSizeSettingContent fontSize={themeFontSize} onChange={this.onFontSizeChange}/>}
                                        overlayClassName="e8left-e9header-font-setting-overlay"
                                        visible={fontSettingVisible}
                                        onVisibleChange={(visible) => portalThemeStore.onFontSettingVisibleChange(visible)}
                                    >
                                        <div className="e9header-account-setting-item" title={item.name} style={{paddingRight: 100}}>
                                            <i className={item.icon} />
                                            <span className="e9header-account-setting-title">{item.name}</span>
                                            <span style={{position: 'absolute', right: '40px'}}>{{'12': getLabel(149, '默认'), '14': getLabel(18145, '中'), '16': getLabel(18144, '大')}[themeFontSize]}</span>
                                            <i className="icon-coms-organization-right" style={{position: 'absolute', right: '10px'}}/>
                                        </div>
                                    </Popover>
                                )
                            } else if (item.sType == 'language' && multiLangs && multiLangs.length > 1) {
                                return (
                                    <Popover
                                        key={index}
                                        trigger="click"
                                        placement="leftTop"
                                        content={<LangSettingContent langId={langId} multiLangs={multiLangs} onChange={this.onLangChange}/>}
                                        overlayClassName="e8left-e9header-lang-setting-overlay"
                                        visible={langSettingVisible}
                                        onVisibleChange={(visible) => portalThemeStore.onLangSettingVisibleChange(visible)}
                                    >
                                        <div className="e9header-account-setting-item" title={item.name} style={{paddingRight: 100}}>
                                            <i className={item.icon} />
                                            <span className="e9header-account-setting-title">{item.name}</span>
                                            <span style={{position: 'absolute', right: '40px'}}>{langText}</span>
                                            <i className="icon-coms-organization-right" style={{position: 'absolute', right: '10px'}}/>
                                        </div>
                                    </Popover>
                                );
                            }else {
                                return null;
                            }
                        })
                    }
                </div>
            </div>
        );

        return (
            <div className="e8left-lmt">
                <div className="e8left-lmt-hrm" style={hrmcolor ? {backgroundColor: hrmcolor} : {}}>
                    <span className="e8left-lmt-hrm-user" title={username} onClick={() => portalThemeStore.onLoadMain({mobxrouteurl: '/hrm/card/cardInfo'})}>{username}</span>
                    <span className="e8left-lmt-hrm-dept" title={deptname}>{deptname}</span>
                    {
                        (
                            <Popover 
                                trigger="click" 
                                placement="bottom" 
                                content={aclistComp}
                                overlayClassName="e8left-account-overlay "
                                visible={accountListVisible}
                                onVisibleChange={this.onVisibleChange}
                            >
                                <span className="e8left-lmt-account-icon">
                                    <i className="wevicon-account-arrow"/>
                                </span>
                                {/* <span className="e8left-lmt-hrm-aclist" title={getLabel(131608, '主次账号切换')}/> */}
                            </Popover>
                        )
                    }
                </div>
                <div className="e8left-lmt-tmn" style={topMenuId == '536' ? {borderBottom: 'none'} : {}}>
                    <span>{topMenuName}</span>
                </div>
                {topMenuId == '536' ? <E8LeftMenuTop4Email {...this.props} /> : ''}
            </div>
        );
    }

    onVisibleChange(visible) {
        const {portalThemeStore} = this.props;
        portalThemeStore.onAccountListVisibleChange(visible);

        const themeLayoutMask = document.getElementById('themeLayoutMask');
        if (visible) {
            themeLayoutMask.style.display = 'block';
        } else {
            themeLayoutMask.style.display = 'none';
        }
    }

    onOpenCard(e, userid) {
        e.preventDefault && e.preventDefault();
        e.stopPropagation && e.stopPropagation();
        
        const {portalThemeStore} = this.props;
        this.onVisibleChange(false);
        portalThemeStore.onLoadMain({mobxrouteurl: `/hrm/card/cardInfo/${userid}`});
    }

    onChangeAccount(userid) {
        WeaTools.ls.set('isInitLSValue', false);
        window.location.href = `/login/IdentityShift.jsp?shiftid=${userid}`;
    }
    
    onFontSizeChange(fontSize) {
        const {portalThemeStore} = this.props;
        portalThemeStore.onFontSizeChange(fontSize);
        portalThemeStore.onFontSettingVisibleChange(false);
    }

    onLangChange(langId, langText) {
        const {portalThemeStore} = this.props;
        portalThemeStore.onLangChange(langId, langText);
        portalThemeStore.onLangSettingVisibleChange(false);
    }
}
class FontSizeSettingContent extends React.Component {
    
    render() {
        const {fontSize} = this.props;
        const selectedComp = <i className="icon-coms-Selected e9header-font-setting-selected"/>;
        
        return (
            <div className="e9header-font-setting-content">
                <div className="e9header-font-setting-item" onClick={() => this.props.onChange('16')}>
                    <i className="icon-coms-text" style={{fontSize: '16px'}}/>
                    <span style={{fontSize: '16px', marginLeft: '8px'}}>{getLabel(18144, '大')}</span>
                    {fontSize == '16' ? selectedComp : ''}
                </div>
                <div className="e9header-font-setting-item" onClick={() => this.props.onChange('14')}>
                    <i className="icon-coms-text" style={{fontSize: '14px'}}/>
                    <span style={{fontSize: '14px', marginLeft: '10px'}}>{getLabel(18145, '中')}</span>
                    {fontSize == '14' ? selectedComp : ''}
                </div>
                <div className="e9header-font-setting-item" onClick={() => this.props.onChange('12')}>
                    <i className="icon-coms-text" style={{fontSize: '12px'}}/>
                    <span style={{fontSize: '12px', marginLeft: '12px'}}>{getLabel(149, '默认')}</span>
                    {fontSize == '12' ? selectedComp : ''}
                </div>
            </div>
        );
    }
}

class LangSettingContent extends React.Component {
    render() {
        const selectedComp = <i className="icon-coms-Selected e9header-lang-setting-selected"/>;

        return (
            <div className="e9header-lang-setting-content">
                {
                    this.props.multiLangs.map((item, index) => {
                        return (
                            <div key={index} className="e9header-lang-setting-item" onClick={() => this.props.onChange(item.id, item.language)}>
                                <span>{item.language}</span>
                                {item.id == this.props.langId ? selectedComp : ''}
                            </div>
                        );
                    })
                }
            </div>
        );
    }
}

export default E8LeftMenuTop;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/theme/ecology8/E8LeftMenuTop.js